import { useTranslation } from "react-i18next";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Card, CardContent } from "@/components/ui/card";

/**
 * Contact Page
 * 
 * IMPORTANT: This page must be accessible to all users, including those who are not logged in.
 * No authentication checks should be added to this component.
 */
export function Contact() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container py-8 px-4 flex items-center justify-center">
        <div className="max-w-md mx-auto w-full">
          <Card className="text-center">
            <CardContent className="pt-12 pb-12">
              <div className="flex justify-center mb-8">
                <img
                  src="/images/splash.png"
                  alt="GreenAR Logo"
                  className="h-64 w-auto drop-shadow-lg"
                />
              </div>
              <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                {t("contact.comingSoon", "Coming Soon")}
              </h1>
              <p className="text-lg text-muted-foreground">
                {t("contact.message", "We're working on something great. Check back soon!")}
              </p>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
}
